var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('nav',{staticClass:"nav-extended indigo darken-2"},[_c('div',{staticClass:"nav-content"},[_c('router-link',{attrs:{"to":{name: 'ScenarioStart' }}},[_c('span',{staticClass:"nav-title"},[_vm._v("Gloomhaven Initiative™")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46bbf34f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = null
// module chunks = 